import { render } from "./G4s.vue?vue&type=template&id=ccbef650"
import script from "./G4s.vue?vue&type=script&lang=js"
export * from "./G4s.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__